<div class="d-flex align-items-center justify-content-center">
  <nb-card>
    <nb-card-header class="d-flex flex-column align-items-center p-4">
      <img src="assets/img/logo.png" height="32px" />
      <div class="mt-2" style="font-size: large">Insight Engine UI - {{ environment }}</div>
    </nb-card-header>
    <nb-card-body class="d-flex flex-column align-items-center p-4">
      <app-spinner></app-spinner>
      <div style="font-size: medium; font-weight: 600" i18n>Logging in...</div>
    </nb-card-body>
  </nb-card>
</div>
